import { Component, OnInit } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import {GapService} from '../../api/services/gap/gap.service';
import {GlobalService} from '../../api/services/global/global.service';
import {TokenService} from '../../api/services/token/token.service';
import {QuoteStatus} from '../../enums/quote-status.enum';
import {Router} from '@angular/router';
import {GapQuoteDetail} from '../../api/models/gap-quote-detail';

@Component({
  selector: 'app-view-quotes',
  templateUrl: './view-quotes.component.html',
  styleUrls: ['./view-quotes.component.css']
})
export class ViewQuotesComponent implements OnInit {
  showError = false;
  hideButton = false;
  errorMessage = '';
  btnSpinner: boolean = false;
  quotes: GapQuoteDetail[];

  constructor(private gapService: GapService,
              private tokenService: TokenService,
              protected globalService: GlobalService,
              private router: Router
  ) {
  }

  ngOnInit() {
    this.globalService.scrollToTop();

    const token = this.getToken();

    if (!token){
      this.showError = true;
      this.hideButton = true;
      this.errorMessage = 'There is no token.';
      return;
    }

    if (!this.globalService.returnedToHome) {
      this.tokenService.getPayloadFromTokenResponse(token).subscribe(
        (payloadResponse) => {
          try {
            const payload = JSON.parse(payloadResponse.payload);
            const leadId = payload.leadId;

            if (!leadId){
              this.showError = true;
              this.hideButton = true;
              this.errorMessage = 'The token is invalid.';
              return;
            }

            this.globalService.leadId = leadId.toString();
            this.getQuoteDetails();
          } catch (e){
            this.showError = true;
            this.hideButton = true;
            this.errorMessage = 'The token is invalid.';
          }
        },
        error => {
          this.showError = true;
          this.hideButton = true;
          this.errorMessage = 'The token is invalid.';
        }
      );
    } else {
      this.getQuoteDetails();
    }
  }

  getToken() {
    const url = window.parent.location.href;
    let paramValue;
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = httpParams.get('token');
    }
    return paramValue;
  }

  startApplication() {
    window.parent.location.href = this.globalService.gapQuoteDetailsResponse.apiUrl;
  }

  protected getHealthPolicyMembers(): void {
    this.gapService.getHealthPolicyMembers().subscribe(response => {
        if (response) {
          if (response.members){
            this.btnSpinner = true;
            this.globalService.healthPolicyMembers = response;
            this.router.navigateByUrl('create-quote').then(navigated => {
              if (navigated) {
                this.btnSpinner = false;
              }
            });
          }
          else {
            this.btnSpinner = false;
            this.hideButton = true;
            this.showError = true;
            this.errorMessage = 'Gap cover is not available for ' + response.mainMemberSchemePlan;
          }
        }
      },
      () => {
      this.btnSpinner = false;
      this.hideButton = true;
      this.showError = true;
      this.errorMessage = 'Failed to retrieve health policy for main member.';
      });
  }

  protected readonly QuoteStatus = QuoteStatus;

  private getQuoteDetails(): void {
    this.gapService
      .getGapQuotesDetails(this.globalService.leadId)
      .subscribe(response => {
          this.globalService.clientEmail = response.clientEmail;
          if (response.QuoteDetails && response.QuoteDetails.length !== 0) {
            this.globalService.gapQuoteDetailsResponse = response;
            this.quotes = response.QuoteDetails;
          } else {
            this.showError = true;
            this.hideButton = false;
            this.errorMessage = 'There are no Gap quotes linked to the lead, please create a Gap quote.'
          }
        },
        error => {
          if (error.status === 403) {
            this.showError = true;
            this.hideButton = true;
            this.errorMessage = 'Access denied. Your user profile is not enabled to view this function.'
          } else {
            this.showError = true;
            this.hideButton = false;
            this.errorMessage = 'There are no Gap quotes linked to the lead, please create a Gap quote.'
          }
        });
  }
}
